import { motion } from 'framer-motion';

import { NewToggle } from '@/components/atoms/toggle/NewToggle';

import { requestLanguages } from '../constants/languages';

type RequestLanguageToggleProps = {
  selectedIndex: number;
  setSelectedIndex: React.Dispatch<React.SetStateAction<number>>;
};

export const RequestLanguageToggle = ({
  selectedIndex,
  setSelectedIndex,
}: RequestLanguageToggleProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
    >
      <NewToggle
        options={requestLanguages as unknown as string[]}
        size='s'
        selectedIndex={selectedIndex}
        onValueChange={(i) => setSelectedIndex(i)}
        responsive={false}
        themeSwitchMode='normal'
      />
    </motion.div>
  );
};
